import { render, staticRenderFns } from "./cardTypeOne.vue?vue&type=template&id=8e874cba&scoped=true"
import script from "./cardTypeOne.vue?vue&type=script&lang=js"
export * from "./cardTypeOne.vue?vue&type=script&lang=js"
import style0 from "./cardTypeOne.vue?vue&type=style&index=0&id=8e874cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e874cba",
  null
  
)

export default component.exports